/**
 * Libellé affichable pour une conversation (BL-0163).
 * Retourne le placeholder si title est null, vide ou blanc.
 */
export function u3204ResolveConversationDisplayTitle(
  title: string | null | undefined,
  placeholderLabel: string,
): string {
  const trimmed = title?.trim();
  return trimmed ? trimmed : placeholderLabel;
}
